import store from "../../utilities/store";
import React, {Component} from "react";
import { Provider } from 'react-redux';
import ToastContainer from './ToastContainer'

export default class Toast extends Component {
  render() {
    return (
      <Provider store={store} >
        <ToastContainer {...this.props} />
      </Provider>
    )
  }
}
